import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import HomePage from './components/HomePage';
import MenuPage from './components/MenuPage';
import GiftBoxPage from './components/GiftBoxPage';
import CartPage from './components/CartPage';
import MyOrdersPage from './components/MyOrdersPage';
import AdminPage from './components/AdminPage';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancelled from './components/PaymentCancelled';
import useRipple from './hooks/useRipple';
import './index.css';

/** Every route change starts at the top, the way a native screen push does. */
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

export default function App() {
    useRipple();

    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/gift-box" element={<GiftBoxPage />} />
                <Route path="/cong-thuc" element={<Navigate to="/admin?tab=recipe" replace />} />
                <Route path="/recipe" element={<Navigate to="/admin?tab=recipe" replace />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/my-orders" element={<MyOrdersPage />} />
                <Route path="/list-bill" element={<MyOrdersPage />} />
                <Route path="/bill" element={<MyOrdersPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/billAdmin" element={<Navigate to="/admin" replace />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-cancelled" element={<PaymentCancelled />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}
